import React from "react";
import { CyberScoreCombined } from "../../../hooks/services/getCyberScoreCombined";
import ProfilePictures from "./ProfilePictures";
import { useLinkedinProfilePics } from "../../../hooks/useLinkedinProfilePics";

type Props = {
  cyberScore: CyberScoreCombined;
  domain: string | undefined;
  onLoadingStateChange: (isLoading: boolean) => void;
};

export default function ProfilePicturesWithLoadingState({ 
  cyberScore, 
  domain,
  onLoadingStateChange 
}: Props) {
  const { isLoading } = useLinkedinProfilePics(domain, cyberScore);
  
  React.useEffect(() => {
    onLoadingStateChange(isLoading);
  }, [isLoading, onLoadingStateChange]);

  return <ProfilePictures domain={domain} cyberScore={cyberScore} />;
}